module.exports = __webpack_public_path__ + "static/media/justin.09b07ee6.png";